import { useEffect } from 'react';

const API_URL = import.meta.env.VITE_API_URL;

/**
 * Hook para rastrear acesso à página.
 * O geo-IP é resolvido no backend pelo IP real do cliente.
 * Um guard de sessionStorage evita múltiplos disparos na mesma sessão.
 */
export const useAccessTracking = () => {
  useEffect(() => {
    if (sessionStorage.getItem('access-tracked')) return;

    const trackAccess = async () => {
      try {
        const response = await fetch(`${API_URL}/track-access`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({}),
        });

        if (response.ok) {
          sessionStorage.setItem('access-tracked', '1');
        }
      } catch (error) {
        console.error('Erro ao rastrear acesso:', error);
      }
    };

    trackAccess();
  }, []);
};
